import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import strings from "translate/language";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PALETTE = ["#4466f2", "#0ea5e9", "#14b8a6"];

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  plugins: {
    legend: {
      display: true,
      position: "top",
      align: "end",
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        borderRadius: 3,
        useBorderRadius: true,
        color: "#64748b",
        font: { size: 12, weight: "500" },
        padding: 16,
      },
    },
    title: { display: false },
    tooltip: {
      backgroundColor: "#0f172a",
      titleColor: "#ffffff",
      bodyColor: "#e2e8f0",
      padding: 12,
      cornerRadius: 8,
      callbacks: {
        label(ctx) {
          const label = ctx.dataset?.label ? `${ctx.dataset.label}: ` : "";
          const value = ctx.parsed?.y;
          return `${label}${value ?? 0}`;
        },
      },
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: "#64748b", font: { size: 12 } },
      border: { display: false },
    },
    y: {
      beginAtZero: true,
      grace: "5%",
      grid: { color: "#eef2f7", drawBorder: false },
      ticks: {
        color: "#64748b",
        font: { size: 12 },
        precision: 0,
        stepSize: undefined,
      },
      border: { display: false },
    },
  },
};

const styleDatasets = (datasets = []) =>
  datasets.map((ds, i) => {
    const color = PALETTE[i % PALETTE.length];
    return {
      ...ds,
      backgroundColor: color,
      borderColor: color,
      borderWidth: 0,
      borderRadius: 4,
      borderSkipped: false,
      maxBarThickness: 36,
      categoryPercentage: 0.7,
      barPercentage: 0.85,
    };
  });

export function Marketchart(props) {
  const { options = defaultOptions, labels = [], datasets } = props;
  const data = useMemo(
    () => ({
      labels,
      datasets: styleDatasets(
        datasets || [
          {
            label: strings.noOfProperty,
            data: labels.map(() => 0),
          },
          {
            label: strings.noOfUser,
            data: labels.map(() => 0),
          },
          {
            label: strings.channelParters,
            data: labels.map(() => 0),
          },
        ]
      ),
    }),
    [labels, datasets]
  );
  return <Bar options={options} data={data} />;
}
